// todo: consolidate tese strings with these and simliar ones

export const SKILL = 'skills';
export const WORK_EXPERIENCE = 'workExperiences';
export const SUMMARY = 'summaries';
export const ACCOMPLISHMENT = 'accomplishments';
export const AFFILIATION = 'affiliations';
export const CERTIFICATION = 'certifications';

export const SKILL_V2 = 'Skills';
export const WORK_EXPERIENCE_V2 = 'WorkExperiences';
export const SUMMARY_V2 = 'Summaries';
export const ACCOMPLISHMENT_V2 = 'Accomplishments';
export const AFFILIATION_V2 = 'Affiliations';
export const CERTIFICATION_V2 = 'Certifications';
